var $fbc93bc02f49c9db$exports = {};
// Instantiate TabPanelWidget
Tabpanelwidget.autoinstall();


//# sourceMappingURL=tab.js.map
